module.exports = __webpack_public_path__ + "static/img/lun_12.b89db1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_12.jpg
// module id = q9fG
// module chunks = 1